import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
// import { selectisAuthenticated } from "../../../features/auth/authSlice";
import { selectPatientelleGrid } from "../../features/patientelle/patientelleSlice";
import { Button, Form, Container, Card, Grid } from "semantic-ui-react";
import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import { GetAllType_D_Operation, GetALLCLINICS } from "../Api/api";
import { server } from "../../App";
import { toast } from "react-toastify";
import axios from "axios";
import { useWindowSize } from "react-use";
import SpeedDialComponent from "../SpeedDial/SpeedDialComponent"
import useGetDoctors from "../../CustomHooks/useGetDoctors";

function CreatePatientelle() {
  const data = useGetDoctors()
  const [show, setShow] = useState(true)
  const { width } = useWindowSize();
  const { register, handleSubmit } = useForm();
  const PatientelleState = useSelector(selectPatientelleGrid);
  const {
    idpatient,
    cin,
    AGEPATIENT,
    date_naissance,
    civilite,
    nom,
    prenom,
    tel,
    nom_mutuelle,
  } = PatientelleState;

  const Type_D_Operation = useQuery("GetAllType_D_Operation", () =>
    GetAllType_D_Operation()
  );

  let Type_D_Operation_list = "";

  if (Type_D_Operation?.data) {
    Type_D_Operation_list = Type_D_Operation?.data.map((item, index) => (
      <option className="item" key={index} value={item.idType_D_Operation}>
        {item.Nom_Type_D_Operationcol}
      </option>
    ));
  }

  const Type_clinic = useQuery("GetALLCLINICS", () =>
    GetALLCLINICS()
  );

  let Type_clinic_list = "";

  if (Type_clinic?.data) {
    Type_clinic_list = Type_clinic?.data.map((item, index) => (
      <option className="item" key={index} value={item.idclinique}>
        {item.NomClinique}
      </option>
    ));
  }

  const CreateOneUser = (data) => {
    return axios({
      method: "POST",
      responseType: "json",
      url: `${server}PriseEnCharge`,
      data: data,
      headers: {
        jwtoken: sessionStorage.token,
      },
    })
      .then((response) => {
        toast.success("Successfully created", {
          position: toast.POSITION.TOP_CENTER,
        });

        return response;
      })
      .catch(() =>
        toast.error("error", {
          position: toast.POSITION.TOP_CENTER,
        })
      );
  };

  // {dateDeSoumission,statut,contact,FK_id_Patient_Prise,fk_id_clinique,FK_id_type_D_Operation}
  // http://localhost:23046/PriseEnCharge/GetAllType_D_Operation

  // console.log(PatientelleState);
  const onSubmit = (data) => {
    data.FK_id_Patient_Prise = idpatient;
    CreateOneUser(data);
    setShow(false)
  };

  let displayLayout = "";
  if (width < 900 && width > 450) {
    displayLayout = (
      <Grid columns="equal" centered className="fixWidth">
        <Grid.Row className="NonPaddingBotom">
          <Grid.Column>
            <Form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
              <div className="required field">
                <label>Clinique</label>
                <select
                  name="fk_id_clinique"
                  role="listbox"
                  aria-expanded="false"
                  className="ui selection dropdown"
                  {...register("fk_id_clinique")}
                >
                  <option className="item" value={0}>
                    choisissez une option
                  </option>
                  {Type_clinic_list}
                </select>
              </div>

              <div className="required field">
                <label>Opération</label>
                <select
                  name="FK_id_type_D_Operation"
                  role="listbox"
                  aria-expanded="false"
                  className="ui selection dropdown"
                  required
                  {...register("FK_id_type_D_Operation")}
                >
                  <option className="item" value={0}>
                    choisissez une option
                  </option>
                  {Type_D_Operation_list}
                </select>
              </div>
              <Button floated="right" positive>
                Enregistrer
              </Button>

              <Link to="/PatientelleGridPriseEnCharge">
                <Button floated="right" color="blue">
                  retour
                </Button>
              </Link>
            </Form>
          </Grid.Column>
          <Grid.Column>
            <Form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
              <div className="required field">
                <label>Date de soumission</label>
                <div className="ui input">
                  <input
                    type="date"
                    name="dateDeSoumission"
                    required
                    min="1900-01-01"
                    max="3018-12-31"
                    {...register("dateDeSoumission")}
                  ></input>
                </div>
              </div>
              <div className="required field">
                <label>Medecin</label>
                <select
                  name="FK_id_medecin2"
                  // role="listbox"
                  aria-expanded="false"
                  className="ui selection dropdown"
                  required
                  {...register("FK_id_medecin2")}
                >
                  {data?.Doctors_list}
                </select>
              </div>
              <div className=" field">
                <label>Commentaire</label>
                <div className="ui form">
                  <textarea
                    placeholder="Commentaire"
                    name="comentaire"
                    maxLength={9000}
                    type="text"
                    {...register("comentaire")}
                    rows="3"
                  />
                </div>
              </div>
            </Form>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  } else {
    displayLayout = (
      <Form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
        <Form.Group widths="equal">
          <div className="required field">
            <label>Clinique</label>
            <select
              name="fk_id_clinique"
              // role="listbox"
              aria-expanded="false"
              className="ui selection dropdown"
              {...register("fk_id_clinique")}
            >
              <option className="item" value={0}>
                choisissez une option
              </option>
              {Type_clinic_list}
            </select>
          </div>

          <div className="required field">
            <label>Opération</label>
            <select
              name="FK_id_type_D_Operation"
              // role="listbox"
              aria-expanded="false"
              className="ui selection dropdown"
              required
              {...register("FK_id_type_D_Operation")}
            >
              <option className="item" value={0}>
                choisissez une option
              </option>
              {Type_D_Operation_list}
            </select>
          </div>

          <div className="required field">
            <label>Date de soumission</label>
            <div className="ui input">
              <input
                type="date"
                name="dateDeSoumission"
                required
                min="1900-01-01"
                max="3018-12-31"
                {...register("dateDeSoumission")}
              ></input>
            </div>
          </div>
          <div className="required field">
            <label>Medecin</label>
            <select
              name="FK_id_medecin2"
              // role="listbox"
              aria-expanded="false"
              className="ui selection dropdown"
              required
              {...register("FK_id_medecin2")}
            >
              {data?.Doctors_list}
            </select>
          </div>
        </Form.Group>

        <div className=" field">
          <label>Commentaire</label>
          <div className="ui form">
            <textarea
              placeholder="Commentaire"
              name="comentaire"
              maxLength={9000}
              type="text"
              {...register("comentaire")}
              rows="3"
            />
          </div>
        </div>
        {/* ================READ FILE LOGIC======================= */}
        {/* <input name="textfile" type="file" accept="text/plain" ref={register} onChange={q} /> */}
        {/* ================READ FILE LOGIC======================= */}

        {show ?
          <Button floated="right" positive>
            Enregistrer
          </Button> : ""
        }

        <Link to="/PatientelleGridPriseEnCharge">
          <Button floated="right" color="blue">
            retour
          </Button>
        </Link>
      </Form>
    );
  }

  return (
    <>
      <div className="heightFix">
        <br />
        <br />
        <br />
        <Container>
          <Card centered raised>
            <Card.Content>
              <Card.Header>
                {civilite} {nom} {prenom}
              </Card.Header>
              <Card.Meta>
                Age : {parseInt(AGEPATIENT)} ans <br></br> Cin : {cin}{" "}
              </Card.Meta>
              <Card.Description>
                Mutuelle : {nom_mutuelle} <br></br> Date de naissance :{" "}
                {date_naissance} <br></br>Tel : {tel}
              </Card.Description>
            </Card.Content>
          </Card>

          <br />
          <br />
          {displayLayout}
          {/* {loadingComponent} */}
        </Container>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>

      </div>
      <SpeedDialComponent />
    </>
  );
}

export default CreatePatientelle;
